import { render } from "./GB_form.vue?vue&type=template&id=1fc13f50"
import script from "./GB_form.vue?vue&type=script&lang=js"
export * from "./GB_form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__